/* eslint-disable no-useless-escape */
"use client";
import { JWT_KEY } from "@/constants";
import { ROUTE } from "@/types/router";
import { useUserStore } from "@/zustand/user";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DrawerMenu } from "./drawer-menu";
import { Popover, PopoverContent } from "../ui/popover";
import { PopoverTrigger } from "@radix-ui/react-popover";
import { useEffect, useState } from "react";
import { getUsernameFromJwt } from "@/utils/utils";

const settings = [
  {
    title: "Logout",
    icon: "/icons/log-out.svg",
  },
];

const Header = () => {
  const navigate = useNavigate();
  const { updateUser } = useUserStore();
  const [username, setUsername] = useState<string | undefined>();

  useEffect(() => {
    const token = localStorage.getItem(JWT_KEY);
    if (token) {
      const username = getUsernameFromJwt(token);
      setUsername(username || "Admin");
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem(JWT_KEY);
    updateUser({ isLogin: false });
    navigate(ROUTE.Login, { replace: true });
  };

  return (
    <div className="mb-5 flex items-center justify-between">
      <div className="flex items-center gap-4 max-lg:hidden">
        {/* {pathname !== ROUTE.Home && (
          <IconButton
            aria-label="back"
            size="medium"
            sx={{
              border: "1px solid #E2E8F0",
              borderRadius: "8px",
              height: "40px",
              width: "40px",
            }}
            onClick={() => navigate(ROUTE.Home)}
          >
            <img src="/icons/arrow-left.svg" alt="arrow-left" />
          </IconButton>
        )}

        <h2 className="text-3xl font-semibold text-text max-lg:hidden">
          {routerTitle.get(pathname.replace(/\/[a-f0-9\-]{36}/, "") as ROUTE)}
        </h2> */}
      </div>

      <div className="flex items-center justify-center gap-3 lg:hidden">
        <DrawerMenu />

        <div className="flex items-center gap-2.5">
          <img src="/images/logo.png" alt="logo" className="aspect-auto h-[48px] w-[134px] object-contain" />
          <div className="flex items-center rounded bg-[#E0E7FF] px-2 py-0.5">
            <span className="text-[10px] font-medium text-[#322F80]">
              SUPER-ADMIN
            </span>
          </div>
        </div>
      </div>
      <Box sx={{ flexGrow: 0 }}>
        <Popover>
          <PopoverTrigger asChild>
            <div className="flex cursor-pointer items-center gap-3 rounded-[64px] lg:border lg:border-[#E2E8F0] lg:p-2 lg:pr-4">
              <img
                alt="avatar"
                src={"/icons/favicon.svg"}
                className="aspect-square size-8 rounded-full"
              />
              <div className="max-lg:hidden">
                <p className="text-xs font-medium text-text capitalize">{username}</p>
                {/* <p className="text-xs font-normal text-[#64748B]">admin123</p> */}
              </div>

              <PopoverContent
                className="w-full max-md:hidden"
                side="bottom"
                align="end"
              >
                {settings.map((setting) => (
                  <div
                    key={setting.title}
                    onClick={handleLogout}
                    className="flex cursor-pointer items-center gap-3"
                  >
                    <div className="flex size-8 items-center justify-center rounded-lg bg-[#EEF2FF]">
                      <img src={setting.icon} alt="icon" />
                    </div>
                    <p className="text-base text-text">{setting.title}</p>
                  </div>
                ))}
              </PopoverContent>
            </div>
          </PopoverTrigger>
        </Popover>

        {/* <Menu
          sx={{ mt: "60px", padding: "0" }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          {settings.map((setting) => (
            <MenuItem
              key={setting.title}
              onClick={handleLogout}
              sx={{
                width: 340,
                padding: "8px 28px",
              }}
            >
              <div className="flex size-8 items-center justify-center rounded-lg bg-[#EEF2FF]">
                <img src={setting.icon} alt="icon" />
              </div>
              <p className="ml-3 text-base text-text">{setting.title}</p>
            </MenuItem>
          ))}
        </Menu> */}
      </Box>
    </div>
  );
};

export default Header;
